import { ATTACHMENT_STATUSES } from '@/constants'

export const tabOptions = [
  {
    key: ATTACHMENT_STATUSES.approved,
    label: 'Aprobados'
  },
  {
    key: ATTACHMENT_STATUSES.pending,
    label: 'En revisión'
  },
  {
    key: 'restStatus',
    label: 'Pendientes/Rechazados/Vencidos'
  }
]
